import styled from "styled-components";

export const GoodsContainer = styled.div`
	display: flex;
	justify-content: center;
	column-gap: 12px;
	row-gap: 34px;
	flex-flow: wrap;
`;

export const NotificationNotGoods = styled.div`
	display: flex;
	justify-content: center;
	flex: 1;
	border-radius: 15px;
	border: 1px solid #e0d2ca;
	background: #fafafa;
	padding: 25px 50px;
`;

export const ImageContainer = styled.div`
	display: flex;
	width: 200px;
	height: 200px;

	img {
		width: 100%;
		height: 100%;
	}
`;
